import { render, staticRenderFns } from "./_productDetails.vue?vue&type=template&id=76bd4f84"
import script from "./_productDetails.vue?vue&type=script&lang=js"
export * from "./_productDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports